/**
 * @generated SignedSource<<c3865da2bc01039f7ea4faeed4ff8599>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAbtestScenarioPageInput = {
  clientMutationId?: string | null;
  abtestScenarioPageId: string;
};
export type ABTestPatternTableActions_DeleteMutation$variables = {
  input: DeleteAbtestScenarioPageInput;
  connections: ReadonlyArray<string>;
};
export type ABTestPatternTableActions_DeleteMutationVariables = ABTestPatternTableActions_DeleteMutation$variables;
export type ABTestPatternTableActions_DeleteMutation$data = {
  readonly deleteAbtestScenarioPage: {
    readonly deletedAbtestScenarioPageId: string;
  } | null;
};
export type ABTestPatternTableActions_DeleteMutationResponse = ABTestPatternTableActions_DeleteMutation$data;
export type ABTestPatternTableActions_DeleteMutation = {
  variables: ABTestPatternTableActions_DeleteMutationVariables;
  response: ABTestPatternTableActions_DeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAbtestScenarioPageId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestPatternTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteAbtestScenarioPagePayload",
        "kind": "LinkedField",
        "name": "deleteAbtestScenarioPage",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ABTestPatternTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteAbtestScenarioPagePayload",
        "kind": "LinkedField",
        "name": "deleteAbtestScenarioPage",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedAbtestScenarioPageId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d4e54141f00297cb5eb73341fc5c867c",
    "id": null,
    "metadata": {},
    "name": "ABTestPatternTableActions_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ABTestPatternTableActions_DeleteMutation(\n  $input: DeleteAbtestScenarioPageInput!\n) {\n  deleteAbtestScenarioPage(input: $input) {\n    deletedAbtestScenarioPageId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3b91fb5fa85334a7d9a324c8877321b";

export default node;
